$.fn.hasAttr = function(name) {  
  return this.attr(name) !== undefined;
};

$(function() {
  // accessibilty
  $('body').on('keyup', function(e) {
    var _t = $(e.originalEvent.target);
    if (e.key === 'Tab' || e.keyCode === 9) {
      // header menu
      if (_t.parents('.header-menu').length > 0) {
        console.log('header menu', _t);
        if (_t.hasAttr('aria-haspopup')) {
          var expanded = _t.attr('aria-expanded') === 'true';
          _t.attr('aria-expanded', !expanded);
          _t.parents('li').siblings('li').find('> a[aria-expanded]').attr('aria-expanded', false);
          e.preventDefault();
        } else if (_t.parents('.submenu').length == 1) {
          // maintain
          e.preventDefault();
        } else {
          $('.header-menu [aria-haspopup]').attr('aria-expanded', false);
          e.preventDefault();
        }
      }
      // header menu
      
      // footer menu
      if (_t.parents('.footer-menu').length > 0) {
        console.log('footer menu', _t);
        if (_t.hasAttr('aria-expanded') && _t.attr('role') == 'menuitem') {
          var expanded = _t.attr('aria-expanded') === 'true';
          _t.attr('aria-expanded', !expanded);
          _t.parents('li').siblings('li').find('> a[aria-expanded]').attr('aria-expanded', false);
          e.preventDefault();
        } else if (_t.parents('.footer-submenu').length == 1) {
          // maintain
          e.preventDefault();
        } else {
          $('.footer-menu [aria-expanded]').attr('aria-expanded', false);
          e.preventDefault();
        }
      }
      // footer menu
      
      // product group
      if (_t.parents('.product-group__variant-selector').length > 0) {
        console.log('variant selector', _t);
        _t.trigger('click');
        _t.prev().attr('aria-checked', true).attr('checked', true).trigger('change');
        
        _t.parents('.product-group__variant-selector').siblings('.product-group__variant-selector')
          .find('input[role="radio"]').attr('aria-checked', false).removeAttr('checked');
        e.preventDefault();
      }
      // product group
      
      // product dropdown
      if (_t.parents('.product-group__product-selector').length > 0) {
        console.log('product selector', _t);
        if (_t.hasClass('select-dropdown-label')) {
          _t.addClass('active').parents('.product-group__product-selector').siblings('.product-group__product-selector')
            .find('.select-dropdown-label').removeClass('active');
        }
        e.preventDefault();
      }
      // product dropdown
      
      // product info tab
      if (_t.hasClass('product-tab-header')) {
        console.log('product info tab', _t);
        _t.trigger('click');
        e.preventDefault();
      }
      // product info tab

      console.log('tab', e);
      // e.preventDefault();
      // Trigger click action
    } else if (e.key === 'Enter' || e.keyCode === 13) {
      console.log('enter', e);
      // e.preventDefault();
      // Trigger click action
    }
  });

  initHeader();
  $(window).on('load', initHeader);
  $(window).on('scroll', initHeader);
  
  $('#menu-mobile').on('click', function() {
    $('.section-header').toggleClass('active');

    var aria_label = $(this).attr('aria-label'),
        data_label = $(this).attr('data-label');
    $(this).attr('aria-label', data_label);
    $(this).attr('data-label', aria_label);
  });

  $('.header-menu a, .footer-menu a').on('click', function(e) {
    if ($(this).attr('href') == '#') {
      var aria_expanded = Boolean($(this).attr('aria-expanded'));
      $(this).attr('aria-expanded', !aria_expanded);

      $(this).toggleClass('active');
      e.preventDefault();
    }
  });

  $('.header-menu a, .footer-menu a').on('mouseover', function(e) {
    var aria_expanded = $(this).attr('aria-expanded');
    if (typeof aria_expanded !== 'undefined') {
      $(this).attr('aria-expanded', !Boolean(aria_expanded));
      e.preventDefault();
    }
  });
  
  $('.faq-q').on('click', function() {
    $(this).toggleClass('active');
  });

  var mailchimp = $('.mc_embed_signup');
  if (mailchimp.length > 0) {
    $('input.email', mailchimp).attr('placeholder', texts.mailchimp.label.email)
      .attr('aria-label', texts.mailchimp.label.email);
    $('.gdpr-mergeRow input[type="checkbox"]', mailchimp).prop('checked', true);

    mailchimp.each(function() {
      $('form', this).validate({
        submitHandler: function(form) {
          submitMailchimp($(form));
        }
      });
    });
  }

  var newsletter_popup_name = 'newsletter_popup',
      newsletter_popup_cookie = Cookies.get(newsletter_popup_name);
  if (typeof newsletter_popup_cookie === 'undefined') {
    setTimeout(function() {
      $('.newsletter-popup').addClass('active').attr('tabindex', '0');
    }, 10000);

    Cookies.set(newsletter_popup_name, Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15), {
      expires: 7
    });
  } else {
    // $('.newsletter-popup').remove();
  }
  $('.newsletter-popup-content > button').on('click', function() {
    $('.newsletter-popup').remove().removeAttr('tabindex');
  });

  initVideoTestimonialSwiper();
  initProductNoteSwiper();
});

var t = 0;
function initHeader() {
  var T = $(this).scrollTop(),
      h = $('.header').outerHeight() * 1.2;

  if (t > T) {
    $('body').removeClass('header-top').addClass('header-btm');
  } else if (T > h) {
    $('body').addClass('header-top').removeClass('header-btm');
  } else {
    $('body').removeClass('header-top').removeClass('header-btm');
  }

  t = T;
}

function submitMailchimp($form) {
  $('.mce-responses > div').html('').show();
  $form.ajaxSubmit({
    type: 'get',
    url: $form.attr('action').replace('/post?u=', '/post-json?u=') + '&c=?',
    data: $form.serialize(),
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    error: function(err) { 
      $('.mce-error-response').html(err.msg);
    },
    success: function(data) {
      if (data.result != 'success') {
        $('.mce-error-response').html(data.msg);
      } else {
        if ($('.product-preorder-form').length > 0) {
          window.location.href = '/pages/thank-you-reflection';
        } else {

          if ($('.email-signup-banner').length > 0 && $('.mc_embed_signup_success').length > 0) {
            $('.email-signup-banner .content-container').html($('.mc_embed_signup_success').get(0).outerHTML);
            $('.mc_embed_signup_success').addClass('active');
  
            if (window.location.pathname.indexOf('/password') >= 0) {
              $('.newsletter-container').addClass('active')
                .siblings().hide();
            }
          } else {
            $('.mce-success-response').html(data.msg);
          }
        }

        fbq('trackCustom', 'Website Subscription');
      }
    }
  });
}

function initVideoTestimonialSwiper() {
  var video_el = $('.product-testimonial-video');
  var el = $('.video-testimonials-block .swiper');
  if (el.length > 0) {
    var swiper_why_text = new Swiper(".text-testimonials-block .swiper", {
      loop: false,
      loopPreventsSliding: false,
      slidesPerView: 1,
      spaceBetween: 15,
      // centeredSlides: true,
      simulateTouch: false,
      navigation: false,
    });

    var swiper_why_video = new Swiper(".video-testimonials-block .swiper", {
      loop: false,
      loopPreventsSliding: false,
      slidesPerView: 1.5,
      spaceBetween: 15,
      // centeredSlides: true,
      // slideToClickedSlide: true,
      navigation: {
        nextEl: ".video-testimonials-block .swiper-button-next",
        prevEl: ".video-testimonials-block .swiper-button-prev",
      },
      breakpoints: {
        1025: {
          slidesPerView: 2,
          spaceBetween: 30,
          centeredSlides: true,
        },
        1201: {
          slidesPerView: $('.video-testimonials-block .swiper-slide').length > 3 ? 3 : 2,
          spaceBetween: 30,
          centeredSlides: true,
        },
      },
      thumbs: {
        swiper: swiper_why_text,
      },
      on: {
        init: function(swiper) {
          video_el = $('.product-testimonial-video');
          
          $('img', video_el).each(function() {
            $(this).attr('role', 'img');
          });

          video_el.on('click', function(e) {
            var _this = $(this),
                _this_video = $('video', this),
                _this_video_get = _this_video.get(0);
            
            if (_this_video_get.paused) {
              _this.addClass('playing');
              _this_video_get.play()
            } else {
              _this.removeClass('playing');
              _this_video_get.pause();
            }
            
            video_el.each(function() {
              var _t = $(this),
                  _t_video = $('video', this);
                  _t_video_get = _t_video.get(0);
              
              if (video_el.index(_t) != video_el.index(_this) && !_t_video_get.paused) {
                _t.removeClass('playing');
                _t_video_get.pause();
              }
            });

            e.preventDefault();
          });
        },
        slideChange: function(swiper) {
          video_el.each(function() {
            var _t = $(this),
                _t_video = $('video', this);
                _t_video_get = _t_video.get(0);

            if (!_t_video_get.paused) {
              _t.removeClass('playing');
              _t_video_get.pause();
            }
          });
        },
      },
    });
  }
}

function initProductNoteSwiper() {
  var el = $('.product-section-note .swiper');
  if (el.length > 0) {
    var swiper_product_note = new Swiper(".product-section-note .swiper", {
      loop: false,
      // initialSlide: 1,
      autoHeight: true,
      navigation: {
        nextEl: ".product-section-note .swiper-button-next",
        prevEl: ".product-section-note .swiper-button-prev",
      },
      pagination: {
        el: ".product-section-note .swiper-pagination",
        clickable: true,
        renderBullet: function(index, className) {
          var bulvar = $(`.product-section-note .swiper-pagination-bullet`).get(index);
          if (typeof bulvar !== 'undefined') return bullet.outerHTML;

          var slide = $(`.product-section-note .swiper-slide`).get(index);
          var text = $(slide).attr('data-text')
          return `<div class="${className}">
            <span class="swiper-pagination-bullet-text">${text}</span>
          </div>`;
        }
      },
    });
  }
}